
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import { NodePOSTApiAuth } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';

export default function ChaptersDetailsView(props) {
  // const { ChapterData } = props;
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory();

  const LoginState = useSelector((state) => state.LoginState);
  const [classDetails, setClassDetails] = React.useState({})
  const [choose, setChoose] = React.useState(0)
  const [PreviewUrl, setPreviewUrl] = React.useState("")
  const [Youtube, setYoutube] = React.useState(false)
  const [PreviewPressed, setPreviewPressed] = React.useState(false)
  const [PreviewType, setPreviewType] = React.useState("")
  const [PdfURL, setPdfURL] = React.useState("")
  const [ExamFetch, setExamFetch] = React.useState(false);
  const [NotFoundData, setNotFound] = React.useState(false)
  const [courseData, setCourseData] = React.useState({});
  const [ChapterData, setChapterData] = React.useState({});
  const [reload, setReload] = React.useState(false)
  const [superChapter, setSuperChapter] = React.useState("")
  const [courses, setCourses] = React.useState([])
  const [courses2, setCourses2] = React.useState([])
  const [Groups, setGroups] = React.useState([])

  useEffect(() => {
    function ctrlShiftKey(e, keyCode) {
      return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
    }

    document.onkeydown = (e) => {
      // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
      if (
        // event.keyCode === 123 ||
        ctrlShiftKey(e, 'I') ||
        ctrlShiftKey(e, 'J') ||
        ctrlShiftKey(e, 'C') ||
        (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
      )
        return false;
    };
  }, [])
  var slug = location.pathname.slice(15);
  useEffect(() => {
    setExamFetch(false)
    setNotFound(false)
    setReload(true)

    NodePOSTApiAuth({
      userID: LoginState.userID,
      courseslug: slug
    }, "single-course-details")
      .then((response) => {
        if (response.data.error)
          setNotFound(true)
        else {
          console.log(response.data)
          // setCourseData(response.data.course[0])
          var chapter = response.data.chapters[0]
          setClassDetails(chapter)

          var groupsList = response.data.chapters[0].meta.groups == "" ? [] : Object.values(JSON.parse(response.data.chapters[0].meta.groups))
          // console.log(classDetails.meta.groups)
          setGroups(groupsList)
          var allCourse =Object.values(JSON.parse(response.data.chapters[0].meta.course_content)).sort((a, b) => (a.chapter_number - b.chapter_number))
          setCourses(allCourse)
          setCourses2(allCourse)
          setChoose(1)
        }
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
      .finally(() => {
        setExamFetch(true)
        setReload(false)
      })
    console.log(slug)
    const handleContextmenu = e => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu)
    }

  }, [])

  const downloadImage = async (imageurl, filename) => {
    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // const imageUrl = "https://api.oppaonnihakwon.com/wp-content/uploads/2025/01/BUTAB.jpeg";
    var nodejsurl = "https://real-exam.epsexam.com/base64"
    axios({ method: "GET", url: `${nodejsurl}?url=${imageurl}` })
      .then(res => {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${res.data.data}`;
        link.download = filename;
        // setBase64(`data:image/jpeg;base64,${res.data.data}`)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
  };
  return (
    <div style={{ margin: "3px" }}>
      {choose == 1 &&
        <div className="row">
          <div className="col-1"></div>
          <div className="col-10 form-view mt-3">
            <div className="row" style={{ margin: "10px" }}>
              <h2>{classDetails.title.rendered}</h2>
              <section style={{ margin: "10px",display:"inline" }}>
                 <div 
                    style={{display:"inline-block",
                      padding: "10px ", border: "0.5px solid #999", cursor: "pointer",
                      backgroundColor: superChapter == "item" ? "#eee" : "#fff"
                    }}
                    onClick={() => {
                      setSuperChapter("सबै")
                      setCourses(courses2)
                    }}
                  >
                    सबै
                  </div>
                {Groups.map((item, index) => (
                  <div key={index}
                    style={{display:"inline-block",
                      padding: "10px ", border: "0.5px solid #999", cursor: "pointer",
                      backgroundColor: superChapter == item ? "#eee" : "#fff"
                    }}
                    onClick={() => {
                      setSuperChapter(item)
                      setCourses(courses2.filter(a=>a.group==item))
                    }}
                  >
                    {item}
                  </div>
                ))}


              </section>
              <div className="row" style={{ marginLeft: "10px" }}>
                {/* {Object.values(JSON.parse(classDetails.meta.course_content)).sort((a, b) => (a.chapter_number - b.chapter_number)).map((item2, index2) => ( */}
                {
                  courses.map((item2, index2) => (
                    // {Object.values(JSON.parse(classDetails.meta.course_content)).map((item2, index2) => (
                    // {ChapterData.map((item, index) => (
                    <div key={index2} className="col-md-4 col-12">
                      <div className="shadow" style={{ cursor: "pointer", backgroundColor: "#fff", margin: "10px 10px 0 0 ", padding: "10px" }}>
                        {/* <h4>{item2.chapter_number}</h4> */}
                        <h4>{item2.chapter_number}. {item2.title}</h4>
                        <div style={{ fontSize: "12px" }}>{item2.description}</div>
                        <div style={{ fontSize: "10px", textAlign: "right" }}>({item2.time})</div>
                        <div style={{ fontSize: "10px", textAlign: "right" }}>{item2.is_preview}</div>
                        {item2.youtube_id !== "" &&
                          <div style={{ padding: 0, display: "inline" }}
                            onClick={() => {
                              var youtubeid = window.btoa(item2.youtube_id)
                              history.push(`/start-video/${youtubeid}`)
                            }}
                          >
                            <span style={{ border: "1px solid black", borderRadius: 5, padding: "3px 10px", fontSize: "12px" }}> Video</span>
                          </div>
                        }
                        <div style={{ padding: 0, display: "inline" }}>

                          {Object.values(JSON.parse(item2.pdf_list)).map((item4, index4) => (
                            <div key={index4} style={{ display: "inline-block", margin: 3 }}>
                              <span style={{ border: "1px solid black", borderRadius: 5, padding: "3px 10px", fontSize: "12px" }}
                                onClick={() => {
                                  setPreviewType("PDF")
                                  setPdfURL(item4)
                                }}
                              >
                                View PDF
                                {Object.values(JSON.parse(item2.pdf_list)).length == 1 ? "" : index4 + 1}
                              </span>
                            </div>
                          ))}
                        </div>
                        <div style={{ padding: 0, display: "inline" }}>
                          {Object.values(JSON.parse(item2.pdf_list)).map((item4, index4) => (
                            <div key={index4} style={{ display: "inline-block", margin: 3 }}>
                              <span style={{ border: "1px solid black", marginTop: 5, borderRadius: 5, padding: "3px 10px", fontSize: "12px" }}
                                onClick={() => {
                                  downloadImage(item4, `${item4.split("/")[item4.split("/").length - 1].replace(".pdf", "")}.pdf`)
                                }}
                              >
                                Download PDF
                                {Object.values(JSON.parse(item2.pdf_list)).length == 1 ? "" : index4 + 1}
                              </span>
                            </div>
                          ))}
                        </div>
                        <div style={{ marginLeft: "40px", fontSize: "12px" }}>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      }


      {PreviewType == "PDF" &&
        <div class="modal-2" style={{
          userSelect: "none", marginTop: 0, top: 0
        }}>
          <div style={{ width: "100vw" }}
            onClick={() => { setPreviewType("") }}
          >
            <div
              data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div>
            <div>
              <div className='d-sm-block d-none '>
                <iframe style={{ width: "100%", height: "95vh", position: "absolute", zIndex: 1 }}
                  src={`${PdfURL}`} />
              </div>
              <div className='d-block d-sm-none '>
                <iframe style={{ width: "100%", height: "95vh", position: "absolute", zIndex: 1 }}
                  src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${PdfURL}`}
                />

              </div>
              <div >
              </div>
              <div style={{ padding: "37vh 50vw", backgroundColor: "#eee" }}>
                <div className="dot-pulse-2"></div>
              </div>
            </div>
          </div>
        </div>
      }

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }

    </div >
  )
}

